module.exports = __webpack_public_path__ + "img/fi-rr-usb-drive.0ea20e7e.svg";